import { StarRatingIcon } from "../../container/ContainerIcons";
import { starsCalculation } from "../../activity/ActivityUtilities";
import InfoTip from "../../../components/InfoTip";
import { ReactComponent as HelpIcon } from "../../../static/assets/dashboard-help.svg";

const QualityWasteQualitySection = ({ dataVolume, t }) => {
  const rows = Object.keys(dataVolume).map((category) => {
    const stars = starsCalculation(
      dataVolume[category].totalVolumeSortingError,
      dataVolume[category].totalWasteVolume,
    );

    const contaminationRate =
      dataVolume[category].totalVolumeSortingError > 0
        ? Math.max(
            1,
            Math.round(
              (dataVolume[category].totalVolumeSortingError * 100) /
                dataVolume[category].totalWasteVolume,
            ),
          )
        : 0;

    return { category, stars, contaminationRate };
  });

  return (
    <article className="statistics-card min-lg:flex-1 min-lg:min-w-0">
      <div className="dashboard-chart-heading">
        <h5 className="dashboard-chart-title">{t("Waste Quality")}</h5>
        <p className="dashboard-chart-subtitle">
          {t("quality.fluxQuality.subtitle")}
        </p>
      </div>

      <div className="flex flex-col">
        <div className="flex items-center border-b border-[#E5E5E5] pb-2 text-[#000000]">
          <span className="flex-1 font-semibold">{t("Flux")}</span>
          <span className="flex-1 flex items-center justify-center gap-1 font-semibold">
            {t("Quality")}
            <InfoTip icon={HelpIcon} widthMaxRem={16}>
              {t("quality.fluxQuality.tooltip")}
            </InfoTip>
          </span>
          <span className="flex-1 text-right font-semibold">
            {t("quality.undesirables")}
          </span>
        </div>

        {rows.map((row) => (
          <div
            key={row.category}
            className="flex items-center py-3 border-b border-[#E5E5E5] last:border-b-0"
          >
            <span className="flex-1 text-[#000000] font-medium">
              {row.category}
            </span>
            <div className="flex-1 flex justify-center">
              <StarRatingIcon
                numberOfStars={row.stars}
                alignTextAboveStars={false}
                color="#222222"
                iconSize={18}
              />
            </div>
            <span className="flex-1 text-right text-gray-600">
              {row.contaminationRate < 1 ? "<1" : row.contaminationRate}%
            </span>
          </div>
        ))}
      </div>
    </article>
  );
};

export default QualityWasteQualitySection;
